import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Col, Image, Row } from "antd";

import userAuthApi from "../../apis/UserAuth.api";
import { setMenu, setUser } from "../../redux/store/auth/authDuck";
import { setLoading } from "../../redux/store/common/commonDuck";

const SignInComponent = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (values) => {
    setIsLoading(true);

    let param = {
      user_id: values.email,
      password: values.password,
    };
    const res = await userAuthApi.login(param);
    if (res.code === 200) {
      localStorage.setItem("accessToken", res.result.tokenDto.accessToken);
      localStorage.setItem("refreshToken", res.result.tokenDto.refreshToken);
      if (res.result.user && res.result.user.id && res.result.user.id === 1) {
        res.result.user.id = 724;
      }
      dispatch(setUser(res.result.user));
      const menuParam = {
        user_id: res.result.user.id === 724 ? 1 : res.result.user.id,
        system_id: 0,
      };
      const menuRes = await userAuthApi.getMenuList(menuParam);
      dispatch(setMenu(menuRes.result));
      setIsLoading(false);
      history.push(`/`);
    } else {
      window.alert(res.msg);
      setIsLoading(false);
    }
  };

  /**
   * 모바일 처리 mobile -> true
   */
  const [mediaResult, setMediaResult] = useState(null);
  useEffect(() => {
    if (typeof window !== "undefined") {
      const matchQueryList = window.matchMedia("all and (max-width: 768px)");
      setMediaResult(matchQueryList.matches);

      const media = function handleChange(e) {
        setMediaResult(e.matches);
      };

      matchQueryList.addEventListener("change", media);
    }
  }, []);

  const contentStyle = {
    height: "100%",
    lineHeight: "160px",
    textAlign: "center",
    background: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };
  const backgroundStyle = {
    backgroundImage: `url(${process.env.REACT_APP_HOST}/assets/images/sign-in/together1.jpg)`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // backdropFilter: "blur(3px)",
    // backdrop-filter: blur(3px);
  };
  const rowStyle = {
    display: "flex",
    width: "40%",
    height: "65%",
    borderRadius: "8px",
    // boxShadow: "5px 5px 50px 0 rgba(0, 0, 0, 0.6)",
    boxShadow: "0 3px 15px 0 rgba(0, 0, 0, 0.18)",
    overflow: "hidden",
    maxWidth: "400px",
  };
  const rowStyleMobile = {
    display: "flex",
    width: "90%",
    height: "80%",
    maxHeight: "600px",
    borderRadius: "8px",
    boxShadow: "0 3px 15px 0 rgba(0, 0, 0, 0.18)",
    overflow: "hidden",
    flexDirection: "column",
  };
  const submitBtnStyle = !mediaResult
    ? {
        width: "100%",
        minHeight: "2.5rem",
        borderRadius: "3px",
        // boxShadow: "3px 3px 12px 0 rgba(0, 0, 0, 0.16)",
        backgroundColor: "#117ffa",
        padding: "0px",

        fontSize: "16px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: "normal",
        textAlign: "center",
        color: "#ffffff",

        margin: "2rem 0",

        cursor: "pointer",
      }
    : {
        width: "100%",
        minHeight: "2.5rem",
        borderRadius: "3px",
        // boxShadow: "3px 3px 12px 0 rgba(0, 0, 0, 0.16)",
        backgroundColor: "#117ffa",
        padding: "0px",

        fontSize: "16px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: "normal",
        textAlign: "center",
        color: "#ffffff",

        margin: "1rem 0 0",

        cursor: "pointer",
      };
  return (
    <div style={backgroundStyle}>
      <Row style={mediaResult ? rowStyleMobile : rowStyle}>
        {/*<Col span={12} className="signIn_left" style={mediaResult ? {*/}
        {/*    maxWidth: "100%", flex: "0 0 40%"*/}
        {/*} : {height: '100%'}}>*/}
        {/*    <Carousel>*/}
        {/*        <div>*/}
        {/*            /!*<h3 style={contentStyle}><Image src="https://howtoyak.com/images/opengraph.png"/></h3>*!/*/}
        {/*            <Image src={`${process.env.REACT_APP_HOST}/assets/images/sign-in/plutus.png`}*/}
        {/*                   preview={false}*/}
        {/*                   style={{*/}
        {/*                       objectFit: "cover",*/}
        {/*                   }}/>*/}
        {/*        </div>*/}
        {/*        /!*<div>*!/*/}
        {/*        /!*    <h3 style={contentStyle}><Image*!/*/}
        {/*        /!*        src="https://gw.alipayobjects.com/zos/antfincdn/LlvErxo8H9/photo-1503185912284-5271ff81b9a8.webp"/>*!/*/}
        {/*        /!*    </h3>*!/*/}
        {/*        /!*</div>*!/*/}
        {/*        /!*<div>*!/*/}
        {/*        /!*    <h3 style={contentStyle}><Image*!/*/}
        {/*        /!*        src="https://gw.alipayobjects.com/zos/antfincdn/cV16ZqzMjW/photo-1473091540282-9b846e7965e3.webp"/>*!/*/}
        {/*        /!*    </h3>*!/*/}
        {/*        /!*</div>*!/*/}
        {/*        /!*<div>*!/*/}
        {/*        /!*    <h3 style={contentStyle}><Image*!/*/}
        {/*        /!*        src="https://gw.alipayobjects.com/zos/antfincdn/x43I27A55%26/photo-1438109491414-7198515b166b.webp"/>*!/*/}
        {/*        /!*    </h3>*!/*/}
        {/*        /!*</div>*!/*/}

        {/*    </Carousel>*/}
        {/*</Col>*/}
        <Col
          span={24}
          className="signIn_right"
          style={
            mediaResult
              ? {
                  maxWidth: "100%",
                  // flex: "0 0 60%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }
              : {
                  // borderLeft: 'double',
                  // borderColor: '#c8d8e5',
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }
          }
        >
          <form
            onSubmit={handleSubmit(onSubmit)}
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/*<h1 style={{textAlign: 'center', marginBottom: 40}}>VUON 백오피스</h1>*/}
            <Image
              src={`${process.env.REACT_APP_HOST}/assets/images/sign-in/plutus-logo.png`}
              preview={false}
              style={{
                objectFit: "cover",
                width: "85%",
                height: "auto",
                paddingBottom: "50px",
                userSelect: "none",
                margin: "auto",
                maxWidth: "280px",
              }}
            />
            {/*<div style={{height: 90}}>*/}
            <div className={`signIn-input-div`}>
              {/*<p>이메일</p>*/}
              <input
                type="email"
                {...register("email", {
                  required: "이메일을 입력해주세요.",
                })}
                placeholder="이메일을 입력해주세요."
              />
              {errors.email && (
                <p style={{ color: "#ff0000" }}>이메일을 입력하세요.</p>
              )}
            </div>
            {/*<div style={{marginTop: 30, height: 90}}>*/}
            <div className={`signIn-input-div`}>
              {/*<p>비밀번호</p>*/}
              <input
                type="password"
                {...register("password", {
                  required: "비밀번호를 입력해주세요.",
                })}
                placeholder="비밀번호를 입력해주세요."
              />
              {errors.password && (
                <p style={{ color: "#ff0000" }}>비밀번호를 입력하세요.</p>
              )}
            </div>
            <input type="submit" style={submitBtnStyle} value="로그인" />
            <div className={`login-information`}>
              <p>아이디 비밀번호를 잊으셨나요?</p>
              <p id={`gray-font`}>
                담당자에게 연락주시면 빠르게 도움드리겠습니다.
              </p>
            </div>
          </form>
        </Col>
      </Row>
    </div>
  );
};
export default SignInComponent;
